import React from "react";
import { useQuery } from "@apollo/client";
import { getSectionsByChapterId } from "../../queries/sections";
import { useEffect, useState } from "react";
import SectionWaypoint from "./temp/SectionWaypoint";
import Octicon, { FileSymlinkFile } from "@primer/octicons-react";
import config from "../../config/config";
import { useParams } from "react-router";
import detailedMethodsPrint from "../../utils/detailedMethodsPrint";

export default function ChapterDetails({ selectedChapter, selectedVolume }) {
  const { data: secData } = useQuery(
    getSectionsByChapterId(selectedChapter.id)
  );

  const [secDataPrint, setsecDataPrint] = useState([]);

  const { year } = useParams();

  useEffect(() => {
    if (secData && secData.sections)
    {
      const updatedData = detailedMethodsPrint(secData);    
      setsecDataPrint(updatedData);
    } 
  }, [secData]);

  useEffect(() => {
    if (window.location.hash && secData) {
      const id = window.location.hash.replace("#", "");
      const elemToScrollTo = document.getElementById(id);
      const main = document.getElementById("main");
      if (elemToScrollTo && main) {
        main.scrollTop = elemToScrollTo.offsetTop;
      }
    }
  }, [secData]);

  const printer = () => {
    const chapNum = selectedChapter.chapterNumber;
    const volNum = selectedVolume.order;
    const url = `${config.baseUri}/PDF?year=${year}&chapterNumber=${chapNum}&volumeNumber=${volNum}`;
    window.location = url;
  };

  return (
    <div>
      <div className="volume-chapter-number">
        <div>
          {selectedVolume.title}: Chapter {selectedChapter.chapterNumber}
        </div>
        {(year !== '2026' || process.env.REACT_APP_BUILD !== 'production') && (
          <div className="printer" onClick={() => printer()}>
            Download PDF{" "}
            <Octicon className="print-option" icon={FileSymlinkFile} />
          </div>
        )}
      </div>
      <h1>{selectedChapter.title}</h1>
      {secDataPrint && secDataPrint.sections ? (
        secDataPrint.sections.map((section, idx) => {
          return (
            <div key={section.id} className={`${section.slug === "detailed-methods" ? 'detailed-methods-print' : ''}`}>
              <SectionWaypoint
                key={section.title}
                section={section}
                first={idx === 0}
                chapterSlug={selectedChapter.slug}
              />
              {idx !== secDataPrint.sections.length - 2 ? (
                <hr className="horizontal-rule" />
              ) :
              (
                <></>
              )}
            </div>
          );
        })
      ) : (
        <></>
      )}
    </div>
  );
}
